// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EscalateTaskModal-module__modalOverlay___TuPpA {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.35);
}

.EscalateTaskModal-module__modalCard___G6Bt5 {
  width: 100%;
  max-width: 540px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.EscalateTaskModal-module__modalHeader___N1wHD {
  padding: 18px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
}

.EscalateTaskModal-module__modalTitle___v30IK {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  color: #111827;
}

.EscalateTaskModal-module__modalSubtitle___V8A6W {
  margin-top: 4px;
  font-size: 14px;
  line-height: 1.4;
  color: #6b7280;
}

.EscalateTaskModal-module__modalBody___HqsHL {
  padding: 16px 20px 18px;
}

.EscalateTaskModal-module__sectionLabel___k1erc {
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6b7280;
}

.EscalateTaskModal-module__teamGrid___hf5rk {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  margin-bottom: 16px;
}

.EscalateTaskModal-module__teamCard___DqzIs {
  min-height: 80px;
  padding: 12px 8px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.EscalateTaskModal-module__teamCard___DqzIs:hover {
  border-color: #9ca3af;
}

.EscalateTaskModal-module__teamCardActive___c9jjY {
  background: #ffffff;
  border-color: #18181b;
}

.EscalateTaskModal-module__teamIcon___bUMi1 {
  font-size: 18px;
  line-height: 1;
  color: #4b5563;
}

.EscalateTaskModal-module__teamLabel___Sdjy7 {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
  color: #374151;
}

.EscalateTaskModal-module__teamCardActive___c9jjY .EscalateTaskModal-module__teamIcon___bUMi1,
.EscalateTaskModal-module__teamCardActive___c9jjY .EscalateTaskModal-module__teamLabel___Sdjy7 {
  color: #18181b;
}

.EscalateTaskModal-module__checkboxSection___JyIGd {
  margin: 14px -20px 6px;
  padding: 0 20px;
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
}

.EscalateTaskModal-module__checkboxRow___RtHJJ {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 10px 0;
}

.EscalateTaskModal-module__checkboxRow___RtHJJ input {
  width: 14px;
  height: 14px;
  margin: 0;
}

.EscalateTaskModal-module__checkboxLabel___m2_Ae {
  font-size: 14px;
  color: #374151;
  cursor: pointer;
}

.EscalateTaskModal-module__teamSection___zUqVv {
  border-bottom: 1px solid #f3f4f6;
}

.EscalateTaskModal-module__teamSectionHeader___o4iBB {
  width: 100%;
  padding: 10px 20px;
  border: none;
  background: #f9fafb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease;
}

.EscalateTaskModal-module__teamSectionHeader___o4iBB:hover {
  background: #f3f4f6;
}

.EscalateTaskModal-module__teamSectionHeaderActive___uBXzZ {
  background: #f3f4f6;
}

.EscalateTaskModal-module__teamSectionTitleWrap___tmSkB {
  display: flex;
  align-items: center;
  gap: 8px;
}

.EscalateTaskModal-module__teamSectionTitle____rlMd {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.EscalateTaskModal-module__teamSectionCount___Bd5Af {
  font-size: 12px;
  color: #6b7280;
  min-width: 18px;
  text-align: right;
}

.EscalateTaskModal-module__teamSectionChevron___e4JFx {
  font-size: 12px;
  color: #9ca3af;
  transition: transform 0.15s ease;
}

.EscalateTaskModal-module__teamSectionChevronOpen___TOR8H {
  transform: rotate(90deg);
}

.EscalateTaskModal-module__teamSectionList___RazGI {
  display: flex;
  flex-direction: column;
}

.EscalateTaskModal-module__teamSectionList___RazGI > .EscalateTaskModal-module__teamMemberRow___WMJrI + .EscalateTaskModal-module__teamMemberRow___WMJrI {
  border-top: 1px solid #f3f4f6;
}

.EscalateTaskModal-module__teamSectionEmpty___uIGHb {
  padding: 16px 20px;
  font-size: 13px;
  color: #6b7280;
  text-align: center;
}

.EscalateTaskModal-module__teamMemberRow___WMJrI {
  width: 100%;
  padding: 10px 20px;
  border: none;
  border-left: 2px solid transparent;
  border-radius: 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.EscalateTaskModal-module__teamMemberRow___WMJrI:hover {
  background: #f9fafb;
}

.EscalateTaskModal-module__teamMemberRowActive___Ik98E {
  background: #f3f4f6;
  border-left-color: #111827;
}

.EscalateTaskModal-module__teamMemberInfo___HnhQ2 {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.EscalateTaskModal-module__teamMemberName___cPHsl {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.EscalateTaskModal-module__teamMemberRole___knLhT {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.EscalateTaskModal-module__teamMemberCheck___bjgNk {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.EscalateTaskModal-module__reasonInput___AZ3Ka {
  width: 100%;
  resize: none;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 14px 16px;
  margin-top: 16px;
  font-size: 14px;
  line-height: 1.4;
  color: #111827;
  background: #ffffff;
}

.EscalateTaskModal-module__reasonInput___AZ3Ka:focus {
  outline: none;
  border-color: #9ca3af;
}

.EscalateTaskModal-module__reasonInput___AZ3Ka::placeholder {
  color: #9ca3af;
}

.EscalateTaskModal-module__modalFooter___NKBz2 {
  border-top: 1px solid #e5e7eb;
  padding: 12px 20px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.EscalateTaskModal-module__modalSecondaryAction___y927c {
  min-width: 88px;
  padding: 8px 14px;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
  cursor: pointer;
}

.EscalateTaskModal-module__modalPrimaryAction___jM8Un {
  min-width: 88px;
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  background: #1f2937;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}

.EscalateTaskModal-module__modalPrimaryAction___jM8Un:disabled {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: default;
}

.EscalateTaskModal-module__modalSecondaryAction___y927c:focus-visible,
.EscalateTaskModal-module__modalPrimaryAction___jM8Un:focus-visible,
.EscalateTaskModal-module__teamCard___DqzIs:focus-visible,
.EscalateTaskModal-module__teamSectionHeader___o4iBB:focus-visible,
.EscalateTaskModal-module__teamMemberRow___WMJrI:focus-visible {
  outline: 2px solid #111827;
  outline-offset: 2px;
}

@media (max-width: 640px) {
  .EscalateTaskModal-module__teamGrid___hf5rk {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.EscalateTaskModal-module__userPicker___jNXG8 {
  margin: -16px -20px 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.EscalateTaskModal-module__searchWrap___aMXgr {
  padding: 14px 20px 12px;
  border-bottom: 1px solid #e5e7eb;
  background: #ffffff;
}

.EscalateTaskModal-module__searchInput___f7MhI {
  width: 100%;
  height: 38px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0 12px;
  font-size: 14px;
  color: #111827;
  background: #ffffff;
}

.EscalateTaskModal-module__searchInput___f7MhI:focus {
  outline: none;
  border-color: #9ca3af;
}

.EscalateTaskModal-module__searchInput___f7MhI::placeholder {
  color: #9ca3af;
}

.EscalateTaskModal-module__teamSections___fUlAv {
  flex: 1 1 auto;
  max-height: 320px;
  overflow-y: auto;
  background: #ffffff;
}

.EscalateTaskModal-module__teamSectionLeft___sztG7 {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.EscalateTaskModal-module__teamSectionIcon___GJyUN {
  font-size: 13px;
  color: #6b7280;
  line-height: 1;
}

.EscalateTaskModal-module__teamSectionChevron___e4JFx {
  width: 10px;
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  transition: transform 0.15s ease;
  flex-shrink: 0;
}

.EscalateTaskModal-module__teamSectionChevronOpen___TOR8H {
  transform: rotate(90deg);
}

.EscalateTaskModal-module__teamSectionList___RazGI {
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.EscalateTaskModal-module__teamMemberRow___WMJrI {
  width: 100%;
  padding: 10px 20px;
  border: none;
  border-left: 2px solid transparent;
  background: #ffffff;
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.EscalateTaskModal-module__teamMemberRow___WMJrI:hover {
  background: #f9fafb;
}

.EscalateTaskModal-module__teamMemberRowActive___Ik98E {
  background: #f3f4f6;
  border-left-color: #111827;
}

.EscalateTaskModal-module__teamMemberAvatar___XM2ED {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #4b5563;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.EscalateTaskModal-module__teamMemberInfo___HnhQ2 {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.EscalateTaskModal-module__teamMemberNameRow___uNH_t {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.EscalateTaskModal-module__teamMemberName___cPHsl {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.EscalateTaskModal-module__teamMemberYou___mEZYv {
  font-size: 12px;
  color: #6b7280;
  flex-shrink: 0;
}

.EscalateTaskModal-module__teamMemberRole___knLhT {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.EscalateTaskModal-module__teamMemberBadge___PxHUm {
  flex-shrink: 0;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  color: #4b5563;
  background: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/EscalateTaskModal/EscalateTaskModal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,+BAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;AACF;;AAEA;EACE,uBAAA;EACA,gCAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,4EACE;AAAJ;;AAKA;EACE,qBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,qBAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAFF;;AAKA;;EAEE,cAAA;AAFF;;AAKA;EACE,sBAAA;EACA,eAAA;EACA,6BAAA;EACA,gCAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,SAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAFF;;AAKA;EACE,gCAAA;AAFF;;AAKA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAFF;;AAKA;EACE,eAAA;EACA,cAAA;EACA,gCAAA;AAFF;;AAKA;EACE,wBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE,6BAAA;AAFF;;AAKA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,0DACE;AAHJ;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,0BAAA;AAJF;;AAOA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAJF;;AAOA;EACE,aAAA;EACA,qBAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;AAJF;;AAOA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAJF;;AAOA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAJF;;AAOA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AAJF;;AAOA;;;;;EAKE,0BAAA;EACA,mBAAA;AAJF;;AAOA;EACE;IACE,gDAAA;EAJF;AACF;AAOA;EACE,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AALF;;AAQA;EACE,uBAAA;EACA,gCAAA;EACA,mBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AALF;;AAQA;EACE,aAAA;EACA,qBAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AALF;;AAQA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AALF;;AAQA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;EACA,cAAA;AALF;;AAQA;EACE,wBAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AALF;;AAQA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,0DACE;AANJ;;AAUA;EACE,mBAAA;AAPF;;AAUA;EACE,mBAAA;EACA,0BAAA;AAPF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAPF;;AAUA;EACE,YAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAPF;;AAUA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAPF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(0, 0, 0, 0.35);\n}\n\n.modalCard {\n  width: 100%;\n  max-width: 540px;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n}\n\n.modalHeader {\n  padding: 18px 20px 14px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modalTitle {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.2;\n  color: #111827;\n}\n\n.modalSubtitle {\n  margin-top: 4px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #6b7280;\n}\n\n.modalBody {\n  padding: 16px 20px 18px;\n}\n\n.sectionLabel {\n  margin-bottom: 10px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #6b7280;\n}\n\n.teamGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 6px;\n  margin-bottom: 16px;\n}\n\n.teamCard {\n  min-height: 80px;\n  padding: 12px 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  text-align: center;\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease,\n    color 0.15s ease;\n}\n\n.teamCard:hover {\n  border-color: #9ca3af;\n}\n\n.teamCardActive {\n  background: #ffffff;\n  border-color: #18181b;\n}\n\n.teamIcon {\n  font-size: 18px;\n  line-height: 1;\n  color: #4b5563;\n}\n\n.teamLabel {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: #374151;\n}\n\n.teamCardActive .teamIcon,\n.teamCardActive .teamLabel {\n  color: #18181b;\n}\n\n.checkboxSection {\n  margin: 14px -20px 6px;\n  padding: 0 20px;\n  border-top: 1px solid #e5e7eb;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.checkboxRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 10px 0;\n}\n\n.checkboxRow input {\n  width: 14px;\n  height: 14px;\n  margin: 0;\n}\n\n.checkboxLabel {\n  font-size: 14px;\n  color: #374151;\n  cursor: pointer;\n}\n\n.teamSection {\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.teamSectionHeader {\n  width: 100%;\n  padding: 10px 20px;\n  border: none;\n  background: #f9fafb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.15s ease;\n}\n\n.teamSectionHeader:hover {\n  background: #f3f4f6;\n}\n\n.teamSectionHeaderActive {\n  background: #f3f4f6;\n}\n\n.teamSectionTitleWrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.teamSectionTitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.teamSectionCount {\n  font-size: 12px;\n  color: #6b7280;\n  min-width: 18px;\n  text-align: right;\n}\n\n.teamSectionChevron {\n  font-size: 12px;\n  color: #9ca3af;\n  transition: transform 0.15s ease;\n}\n\n.teamSectionChevronOpen {\n  transform: rotate(90deg);\n}\n\n.teamSectionList {\n  display: flex;\n  flex-direction: column;\n}\n\n.teamSectionList > .teamMemberRow + .teamMemberRow {\n  border-top: 1px solid #f3f4f6;\n}\n\n.teamSectionEmpty {\n  padding: 16px 20px;\n  font-size: 13px;\n  color: #6b7280;\n  text-align: center;\n}\n\n.teamMemberRow {\n  width: 100%;\n  padding: 10px 20px;\n  border: none;\n  border-left: 2px solid transparent;\n  border-radius: 0;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  cursor: pointer;\n  text-align: left;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.teamMemberRow:hover {\n  background: #f9fafb;\n}\n\n.teamMemberRowActive {\n  background: #f3f4f6;\n  border-left-color: #111827;\n}\n\n.teamMemberInfo {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.teamMemberName {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.teamMemberRole {\n  font-size: 12px;\n  color: #6b7280;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.teamMemberCheck {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.reasonInput {\n  width: 100%;\n  resize: none;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 14px 16px;\n  margin-top: 16px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #111827;\n  background: #ffffff;\n}\n\n.reasonInput:focus {\n  outline: none;\n  border-color: #9ca3af;\n}\n\n.reasonInput::placeholder {\n  color: #9ca3af;\n}\n\n.modalFooter {\n  border-top: 1px solid #e5e7eb;\n  padding: 12px 20px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.modalSecondaryAction {\n  min-width: 88px;\n  padding: 8px 14px;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  color: #4b5563;\n  cursor: pointer;\n}\n\n.modalPrimaryAction {\n  min-width: 88px;\n  padding: 8px 14px;\n  border: none;\n  border-radius: 6px;\n  background: #1f2937;\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.modalPrimaryAction:disabled {\n  background: #e5e7eb;\n  color: #9ca3af;\n  cursor: default;\n}\n\n.modalSecondaryAction:focus-visible,\n.modalPrimaryAction:focus-visible,\n.teamCard:focus-visible,\n.teamSectionHeader:focus-visible,\n.teamMemberRow:focus-visible {\n  outline: 2px solid #111827;\n  outline-offset: 2px;\n}\n\n@media (max-width: 640px) {\n  .teamGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.userPicker {\n  margin: -16px -20px 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.searchWrap {\n  padding: 14px 20px 12px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #ffffff;\n}\n\n.searchInput {\n  width: 100%;\n  height: 38px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 0 12px;\n  font-size: 14px;\n  color: #111827;\n  background: #ffffff;\n}\n\n.searchInput:focus {\n  outline: none;\n  border-color: #9ca3af;\n}\n\n.searchInput::placeholder {\n  color: #9ca3af;\n}\n\n.teamSections {\n  flex: 1 1 auto;\n  max-height: 320px;\n  overflow-y: auto;\n  background: #ffffff;\n}\n\n.teamSectionLeft {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.teamSectionIcon {\n  font-size: 13px;\n  color: #6b7280;\n  line-height: 1;\n}\n\n.teamSectionChevron {\n  width: 10px;\n  text-align: center;\n  font-size: 12px;\n  color: #9ca3af;\n  transition: transform 0.15s ease;\n  flex-shrink: 0;\n}\n\n.teamSectionChevronOpen {\n  transform: rotate(90deg);\n}\n\n.teamSectionList {\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n}\n\n.teamMemberRow {\n  width: 100%;\n  padding: 10px 20px;\n  border: none;\n  border-left: 2px solid transparent;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-align: left;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.teamMemberRow:hover {\n  background: #f9fafb;\n}\n\n.teamMemberRowActive {\n  background: #f3f4f6;\n  border-left-color: #111827;\n}\n\n.teamMemberAvatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #4b5563;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.teamMemberInfo {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.teamMemberNameRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.teamMemberName {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.teamMemberYou {\n  font-size: 12px;\n  color: #6b7280;\n  flex-shrink: 0;\n}\n\n.teamMemberRole {\n  font-size: 12px;\n  color: #6b7280;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.teamMemberBadge {\n  flex-shrink: 0;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  padding: 4px 8px;\n  font-size: 12px;\n  color: #4b5563;\n  background: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `EscalateTaskModal-module__modalOverlay___TuPpA`,
	"modalCard": `EscalateTaskModal-module__modalCard___G6Bt5`,
	"modalHeader": `EscalateTaskModal-module__modalHeader___N1wHD`,
	"modalTitle": `EscalateTaskModal-module__modalTitle___v30IK`,
	"modalSubtitle": `EscalateTaskModal-module__modalSubtitle___V8A6W`,
	"modalBody": `EscalateTaskModal-module__modalBody___HqsHL`,
	"sectionLabel": `EscalateTaskModal-module__sectionLabel___k1erc`,
	"teamGrid": `EscalateTaskModal-module__teamGrid___hf5rk`,
	"teamCard": `EscalateTaskModal-module__teamCard___DqzIs`,
	"teamCardActive": `EscalateTaskModal-module__teamCardActive___c9jjY`,
	"teamIcon": `EscalateTaskModal-module__teamIcon___bUMi1`,
	"teamLabel": `EscalateTaskModal-module__teamLabel___Sdjy7`,
	"checkboxSection": `EscalateTaskModal-module__checkboxSection___JyIGd`,
	"checkboxRow": `EscalateTaskModal-module__checkboxRow___RtHJJ`,
	"checkboxLabel": `EscalateTaskModal-module__checkboxLabel___m2_Ae`,
	"teamSection": `EscalateTaskModal-module__teamSection___zUqVv`,
	"teamSectionHeader": `EscalateTaskModal-module__teamSectionHeader___o4iBB`,
	"teamSectionHeaderActive": `EscalateTaskModal-module__teamSectionHeaderActive___uBXzZ`,
	"teamSectionTitleWrap": `EscalateTaskModal-module__teamSectionTitleWrap___tmSkB`,
	"teamSectionTitle": `EscalateTaskModal-module__teamSectionTitle____rlMd`,
	"teamSectionCount": `EscalateTaskModal-module__teamSectionCount___Bd5Af`,
	"teamSectionChevron": `EscalateTaskModal-module__teamSectionChevron___e4JFx`,
	"teamSectionChevronOpen": `EscalateTaskModal-module__teamSectionChevronOpen___TOR8H`,
	"teamSectionList": `EscalateTaskModal-module__teamSectionList___RazGI`,
	"teamMemberRow": `EscalateTaskModal-module__teamMemberRow___WMJrI`,
	"teamSectionEmpty": `EscalateTaskModal-module__teamSectionEmpty___uIGHb`,
	"teamMemberRowActive": `EscalateTaskModal-module__teamMemberRowActive___Ik98E`,
	"teamMemberInfo": `EscalateTaskModal-module__teamMemberInfo___HnhQ2`,
	"teamMemberName": `EscalateTaskModal-module__teamMemberName___cPHsl`,
	"teamMemberRole": `EscalateTaskModal-module__teamMemberRole___knLhT`,
	"teamMemberCheck": `EscalateTaskModal-module__teamMemberCheck___bjgNk`,
	"reasonInput": `EscalateTaskModal-module__reasonInput___AZ3Ka`,
	"modalFooter": `EscalateTaskModal-module__modalFooter___NKBz2`,
	"modalSecondaryAction": `EscalateTaskModal-module__modalSecondaryAction___y927c`,
	"modalPrimaryAction": `EscalateTaskModal-module__modalPrimaryAction___jM8Un`,
	"userPicker": `EscalateTaskModal-module__userPicker___jNXG8`,
	"searchWrap": `EscalateTaskModal-module__searchWrap___aMXgr`,
	"searchInput": `EscalateTaskModal-module__searchInput___f7MhI`,
	"teamSections": `EscalateTaskModal-module__teamSections___fUlAv`,
	"teamSectionLeft": `EscalateTaskModal-module__teamSectionLeft___sztG7`,
	"teamSectionIcon": `EscalateTaskModal-module__teamSectionIcon___GJyUN`,
	"teamMemberAvatar": `EscalateTaskModal-module__teamMemberAvatar___XM2ED`,
	"teamMemberNameRow": `EscalateTaskModal-module__teamMemberNameRow___uNH_t`,
	"teamMemberYou": `EscalateTaskModal-module__teamMemberYou___mEZYv`,
	"teamMemberBadge": `EscalateTaskModal-module__teamMemberBadge___PxHUm`
};
module.exports = ___CSS_LOADER_EXPORT___;
